import { render, staticRenderFns } from "./DestructionOfPersonalInformationOfDormant.vue?vue&type=template&id=3bb36d2e&scoped=true&"
import script from "./DestructionOfPersonalInformationOfDormant.vue?vue&type=script&lang=js&"
export * from "./DestructionOfPersonalInformationOfDormant.vue?vue&type=script&lang=js&"
import style0 from "./DestructionOfPersonalInformationOfDormant.vue?vue&type=style&index=0&id=3bb36d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb36d2e",
  null
  
)

export default component.exports